import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define a type for a quoted item
interface QuotedItem {
  id: string;
  name: string;
  image: string;
  price: string;
  specs: string; // User-entered specifications
}

// Define a type for the slice state
interface QuoteState {
  quoteItems: QuotedItem[];
}

// Initial state
const initialState: QuoteState = {
  quoteItems: [],
};

const QuoteSlice = createSlice({
  name: "quote",
  initialState,
  reducers: {
    addToQuote: (state, action: PayloadAction<QuotedItem>) => {
      state.quoteItems.push(action.payload);
    },
    removeFromQuote: (state, action: PayloadAction<string>) => {
      state.quoteItems = state.quoteItems.filter(
        (item) => item.id !== action.payload
      );
    },
    clearQuote: (state) => {
      state.quoteItems = []; // Clears all items
    },
  },
});

export const { addToQuote, removeFromQuote, clearQuote } = QuoteSlice.actions;
export default QuoteSlice.reducer;
